
import Offers from '@/graphql/queries/products/Offers'
import { isEven } from 'vessel/utils'

export default {
  props: {
    product: {
      type: Array,
      default: () => []
    }
  },
  vessel: {
    title: {
      fontSize: '3xl',
      textColor: 'black'
    }
  },
  watch: {
    queryVariables: '$fetch'
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Offers,
      variables: this.queryVariables
    })

    this.total    = data.total
    this.products = data.nodes
  },
  data() {
    return {
      products: null,
      skip: 0,
      total: 0,
      columns: { all: 1, md: 2, lg: 2, xl: 2 }
    }
  },
  computed: {
    currentComponent() {
      return this.$screen.lg ? 'ProductOfferCard' : 'ProductCard'
    },
    itemHeight() {
      return this.$screen.lg ? 438 : 263
    },
    nextDisabled() {
      return (this.skip + this.visibleItems) >= this.total
    },
    prevDisabled() {
      return this.skip == 0
    },
    visibleItems() {
      return this.$screen.match(this.columns)
    },
    queryVariables() {
      return { first: this.visibleItems, skip: this.skip, where: { onSale: true } }
    }
  },
  methods: {
    direction(index) {
      return isEven(index) ? 'left' : 'right'
    },
    onNext() {
      if (this.nextDisabled) return
      this.skip = this.nextDisabled ? 0 : this.skip + this.visibleItems
    },
    onPrev() {
      if (this.prevDisabled) return
      this.skip = this.prevDisabled ? 0 : this.skip - this.visibleItems
    }
  }
}
